import { rem } from 'polished';
import styled from 'styled-components';

const ProductsAndServicesItemListTabs = styled.div`
    height: ${({ theme }) => rem(theme.site.products.container.height)};
    margin-top: ${rem(16)};
`;

export default ProductsAndServicesItemListTabs;
